import { useMutation } from "@apollo/client";
import { graphql } from "gql/apollo";
import { CreateContactParams } from "gql/apollo/graphql";
import { useCallback } from "react";
import { ListContactGroups } from "../queries/useListContactGroups";
import { ListContacts } from "../queries/useListContacts";

export const CreateContact = graphql(/* GraphQL */ `
	mutation CreateContact($params: CreateContactParams!) {
		createContact(params: $params) {
			success
			error {
				code
				message
			}
		}
	}
`);

export function useCreateContact() {
	const [createContact] = useMutation(CreateContact, {
		refetchQueries: [ListContacts, ListContactGroups],
	});

	const handleCreateContact = useCallback(
		async (params: CreateContactParams) => {
			const result = await createContact({
				variables: {
					params,
				},
			});

			return {
				success: result.data?.createContact.success,
				error: result.data?.createContact.error,
			};
		},
		[createContact]
	);

	return { handleCreateContact };
}
